import React from "react";
import { useIntl } from "react-intl";
import { PurposedButtonProps } from "./types";
import EwaButton2 from "./EwaButton/EwaButton2";
import { useTheme } from "../../../../config/emotion";

const MobileActionsButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.secondaryColor}
      tooltip={formatMessage({ id: "segments.table.actions" })}
      iconName="list"
      {...props}
    />
  );
};

export default MobileActionsButton;
